module.exports = __webpack_public_path__ + "static/img/menu3.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/menu3.png
// module id = 557
// module chunks = 0